var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading"}},[_c('v-progress-circular',{staticClass:"progressbar",attrs:{"indeterminate":"","size":"50","width":"6"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }